import React, { useState, useEffect } from 'react';
import {
  Outlet,
  useMatches,
  useNavigate
} from "react-router-dom";
import {
  Button,
  Col,
  Container,
  Image,
  Row,
  Tab,
  TabContent,
  Tabs
} from 'react-bootstrap';

import { 
  HiDotsCircleHorizontal,
  HiOutlineChevronLeft,
  HiPlusCircle
} from "react-icons/hi";

import BankingForm from '../../components/BankingForm';
import Integration from '../../components/Integration';
import UserForm from '../../components/UserForm';
import User from '../../components/User';

export default function Account() {

  const navigate = useNavigate();

  const routerMatches = useMatches();

  const [activeTab, setActiveTab] = useState('user_profile');

  const pageName = () => {
    let page = routerMatches[routerMatches.length-1]['pathname'].split('/').reverse().find((val) => val !== "" && isNaN(val))
    if (activeTab && page !== activeTab) setActiveTab(page);
    return page;
  }

  useEffect(() => {
    if (pageName() === "account") navigate("/merchant/account/user_profile", { replace: true });
  }, [pageName]);  

  const navigateToTab = (eventKey, e) => {
    if (e) e.preventDefault();
    navigate("/merchant/account/"+eventKey);
    setActiveTab(eventKey);
    pageName();
  }

  return (
    <>

      <Container className="tab-settings g-0 mt-4 text-start">
	      <Row>
	      	<Col />
	      	<Col xs={12} sm={10}>
				    <Tabs
				      defaultActiveKey="account"
				      id="uncontrolled-tab-example"
				      className="mb-0 small-tabs"
				      fill
              activeKey={activeTab}
              onSelect={navigateToTab}
				    >
				      <Tab eventKey="user_profile" title="Profile" className="flex-sm-fill">
                <p>
                  Manage your profile here
                </p>
				        <UserForm />
				      </Tab>
				      <Tab eventKey="integrations" title="Integrations" className="flex-sm-fill">
                <p>
                  Copy the API key below to use in integrations with your shop management software
                </p>            
                <Integration />
				      </Tab>
				    </Tabs>

	      	</Col>
	      	<Col />
	      </Row>

      </Container>
    </>
  )
}